import Joi from "joi";

export const roleSchema = Joi.object({
  sName: Joi.string().trim().required().messages({
    "string.base": "Role Name must be a string.",
    "string.empty": "Role Name is required.",
    "any.required": "Role Name is required.",
  }),
  sDescription: Joi.string().trim().messages({
    "string.base": "Role Description must be a string.",
    "string.empty": "Role Description is required.",
    "any.required": "Role Description is required.",
  }),
});
